import React, { useState, useRef } from 'react'
import 'react-alice-carousel/lib/alice-carousel.css'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'

import './styles.css'

export default function BackgroundComponent() {
  const renderOurProduct = (
    <div className="background-products-wrapper">
      <div>
        <div className="background-tuna" />
        <div className="background-product-caption">
          <div className="product-caption-title">Just Tuna!</div>
          <div className="product-caption-subtitle">ปลาทูน่าระดับ Human-grade ของแท้ ชิ้นใหญ่ อร่อย อัดแน่นเต็มคำ</div>
        </div>
      </div>
      <div>
        <div className="background-chicken" />
        <div className="background-product-caption">
          <div className="product-caption-title">Tuna topped with Chicken</div>
          <div className="product-caption-subtitle">ไก่ชิ้นพอดีคำ โรยบนปลาทูน่า กลิ่นหอม อร่อยดี Tasty สุดฟิน</div>
        </div>
      </div>
      <div>
        <div className="background-salmon" />
        <div className="background-product-caption">
          <div className="product-caption-title">Tuna topped with Salmon</div>
          <div className="product-caption-subtitle">ปลาแซลมอน โรยบนปลาทูน่า ดึงความอร่อย ผสมผสานกันอย่างลงตัว</div>
        </div>
      </div>
      <div>
        <div className="background-rice-fish" />
        <div className="background-product-caption">
          <div className="product-caption-title">Tuna topped with Shirasu</div>
          <div className="product-caption-subtitle">ปลาชิราสุ โรยบนปลาทูน่า ดึงความอร่อย แบบฉบับญี่ปุ่นในทุกๆ คำ</div>
        </div>
      </div>
    </div>
  )

  const renderOurValue = (
    <>
      <div className="background-value-wrapper"></div>
      <div className="background-value-margin">
        <div className="background-value-top">
          <div className="background-value-width">
            <img alt="" className="background-value-quality" src="/assets/icons/our-value-quality.png" />
            <div className="background-value-title">Japanese quality</div>
            <div className="background-value-subtitle">
              แคทเทสต์ คัดสรรค์วัตถุดิบอย่างพิถีพิถันจนได้วัตถุดิบชั้นดี คุณภาพเดียวกับสินค้า
              <span style={{ whiteSpace: 'nowrap' }}>ส่งออกญี่ปุ่นระดับท็อป</span>
            </div>
          </div>
          <div className="background-value-width">
            <img alt="" className="background-value-human" src="/assets/icons/our-value-human.png" />
            <div className="background-value-title">HUMAN-GRADE FOOD</div>
            <div className="background-value-subtitle">
              แคทเทสต์ เลือกเฉพาะเนื้อปลาทูน่าสีขาว คุณภาพระดับคนทาน ที่คงความ Tasty โดยไม่ละทิ้งความ Healthy
              เพราะน้องแมวไม่ควรได้กินวัตถุดิบเหลือจากอาหารคน!
            </div>
          </div>
        </div>
        <div className="background-value-bottom">
          <div className="background-value-width">
            <img alt="" className="background-value-human" src="/assets/icons/our-value-sodium.png" />
            <div className="background-value-title">No sodium added</div>
            <div className="background-value-subtitle">
              แคทเทสต์ ไม่พึ่งโซเดียม! เรามีเทคนิคการปรุงรสสุดพิเศษเพื่อดึงรสชาติของวัตถุดิบชั้นเยี่ยม สร้างความ Tasty
              ระดับอูมามิ
            </div>
          </div>
          <div className="background-value-width">
            <img alt="" className="background-value-human" src="/assets/icons/our-value-grain.png" />
            <div className="background-value-title">Grain-Free</div>
            <div className="background-value-subtitle">
              แคทเทสต์ ปราศจากเมล็ดธัญพืช ไม่ว่าจะเป็น ข้าวโพด หรือกลูเตน เพราะจะทำให้น้องแมวเกิดอาการแพ้ได้
            </div>
          </div>
          <div className="background-value-width">
            <img alt="" className="background-value-human" src="/assets/icons/our-value-preservative.png" />
            <div className="background-value-title">No Preservatives</div>
            <div id="our-value" className="background-value-subtitle">
              แคทเทสต์ ใช้กรรมวิธีการผลิตที่ดีที่สุด เพื่อคงคุณภาพสินค้าทุกชิ้น โดยไม่ใส่สารกันบูด
              เพื่อสุขภาพในระยะยาวของน้องแมว
            </div>
          </div>
        </div>
      </div>
    </>
  )

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  const renderSliderTasty = (
    <>
      <div className="carousel-header">
        <div className="carousel-tasty-wrapper">
          <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
          <div className="carousel-title-tasty">Tasty</div>
        </div>
        <a className="shop-now-btn" href="product#tasty">
          SHOP NOW
        </a>
      </div>
      <div className="container">
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <Slider {...settings}>
          <a className="carousel-item" href="product-item/chicken-jelly">
            <div className="product-card-img-tuna-chicken-jelly" />
            <div className="carousel-item-title">Tuna topped with Chicken in Jelly</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมวสูตรปลาทูน่า</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าไก่ในเยลลี่</div>
            <div className="carousel-btn-wrapper">
              <a className="carousel-btn" href="https://shopee.co.th/shop/582216451/search?shopCollection=137378615">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.766b5b1foO6sbp&q=All-Products&shop_category_ids=1205129&from=wangpu&sc=KVUG">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="product-item/chicken-gravy">
            <div className="product-card-img-tuna-chicken-gravy" />
            <div className="carousel-item-title">Tuna topped with Chicken in Gravy</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าไก่ในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <a className="carousel-btn" href="https://shopee.co.th/shop/582216451/search?shopCollection=137378615">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.766b5b1foO6sbp&q=All-Products&shop_category_ids=1205129&from=wangpu&sc=KVUG">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="product-item/just-tuna-jelly">
            <div className="product-card-img-just-tuna-jelly" />
            <div className="carousel-item-title">Just Tuna! in Jelly</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเยลลี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378602">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1f5wFmsX&q=All-Products&shop_category_ids=1205128&from=wangpu&sc=KVUG">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="product-item/just-tuna-gravy">
            <div className="product-card-img-just-tuna-gravy" />
            <div className="carousel-item-title">Just Tuna! in Gravy</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378602">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1f5wFmsX&q=All-Products&shop_category_ids=1205128&from=wangpu&sc=KVUG">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="product-item/shirasu-jelly">
            <div className="product-card-img-shirasu-in-jelly" />
            <div className="carousel-item-title">Tuna topped with Shirasu in Jelly</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าหน้าชิระสุในเยลลี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378621">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1fMekH5s&q=All-Products&shop_category_ids=1205131&from=wangpu&sc=KVUG">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="product-item/shirasu-gravy">
            <div className="product-card-img-shirasu-in-gravy" />
            <div className="carousel-item-title">Tuna topped with Shirasu in Gravy</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าหน้าชิระสุในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378621">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1fMekH5s&q=All-Products&shop_category_ids=1205131&from=wangpu&sc=KVUG">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="product-item/salmon-jelly">
            <div className="product-card-img-salmon-in-jelly" />
            <div className="carousel-item-title">Tuna topped with Salmon in Jelly</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าหน้าแซลม่อนในเยลลี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378630">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1flbME86&q=All-Products&shop_category_ids=1205132&from=wangpu&sc=KVUG">
                LAZADA
              </a>
            </div>
          </a>
          <a className="carousel-item" href="product-item/salmon-gravy">
            <div className="product-card-img-salmon-in-gravy" />
            <div className="carousel-item-title">Tuna topped with Salmon in Gravy</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าหน้าแซลม่อนในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <a
                className="carousel-btn"
                href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378630">
                SHOPEE
              </a>
              <a
                className="carousel-btn"
                href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1flbME86&q=All-Products&shop_category_ids=1205132&from=wangpu&sc=KVUG">
                LAZADA
              </a>
            </div>
          </a>
        </Slider>
      </div>
    </>
  )

  const renderSliderHealthyTasty = (
    <>
      <div className="carousel-header">
        <div className="carousel-tasty-wrapper">
          <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
          <div className="carousel-title-healthy">Healthy Tasty</div>
        </div>
        <a className="shop-now-btn" href="product#healthy">
          SHOP NOW
        </a>
      </div>
      <div className="container">
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <Slider {...settings}>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
        </Slider>
      </div>
    </>
  )

  const renderCustomer = (
    <>
      <div className="customer-background"></div>
      <div className="customer-review-wrapper">
        <div className="customer-title-wrapper">
          <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
          <div className="customer-title">What our customers are saying?</div>
        </div>
        <div className="customer-quote-wrapper">
          <div>
            <div className="customer-quote-item">
              <img className="customer-image" src="/assets/icons/simsim_thesimba.jpg" />
              <div className="customer-quote">กินหมด เลียเกลี้ยงจานเลยครับ</div>
            </div>
            <div className="customer-username">simsim_thesimba</div>
          </div>
          <div>
            <div className="customer-quote-item">
              <img className="customer-image" src="/assets/icons/giftchayaa.jpg" />
              <div className="customer-quote">Tasty กับ Healthy จริง รับประกันค่ะ</div>
            </div>
            <div className="customer-username">giftchayaa</div>
          </div>
          <div>
            <div className="customer-quote-item">
              <img className="customer-image" src="/assets/icons/tinatanie.jpg" />
              <div className="customer-quote">อาหารแมวแบบ Human Grade ด้วย ต้องลองค่ะ</div>
            </div>
            <div className="customer-username">tinatanie</div>
          </div>
        </div>
      </div>
    </>
  )

  return (
    <div className="background-wrapper">
      <div className="background" />
      <a id="about-us" style={{ paddingTop: '100px', display: 'block' }} />
      <div className="background-title-wrapper" style={{ paddingTop: '10px' }}>
        <img className="background-title-wrapper-img" alt="cat's taste" src="/assets/icons/logo-title.svg" />
        {/* <div className="background-title">Cat’s Taste</div> */}
        <div className="background-subtitle">
          " <strong>Cat's Taste</strong> อร่อยดี Tasty ทุกคำ " อาหารแมวคุณภาพระดับ Human Grade
          คัดสรรค์วัตถุดิบเกรดญี่ปุ่น ที่มีทั้งความ Tasty และ Healthy การันตีว่าน้องแมวกินหมดจานแน่นอน
        </div>
      </div>
      <div className="background-products-small " />
      <div className="background-products " />
      <a id="our-value" style={{ paddingTop: '100px', display: 'block' }} />
      <div className="our-product-title-wrapper">
        <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
        <div className="our-value-title">Our Value</div>
      </div>
      {renderOurValue}
      <div className="our-value-wrapper-img our-product-margin">
        <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
        <div className="our-value-title">Our Products</div>
      </div>
      {renderOurProduct}
      {renderSliderTasty}
      {/* {renderSliderHealthyTasty} */}
      {renderCustomer}
    </div>
  )
}
